import { useQueryClient } from "@tanstack/react-query";

export const useInvalidateTransactionOrder = (investmentAccountId: string) => {
  const queryClient = useQueryClient();

  return {
    invalidate: async () => {
      await queryClient.invalidateQueries({
        queryKey: [`transaction/orders/get`, { investmentAccountId }],
      });
    },
  };
};
